// bao migrate skip
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "../../factories/bao-dialog";
class SummaryReportFilterTabDialog {
    Dialog: BaoDialog;
    Parent: any;
    SummaryReportFilterId: KnockoutObservable<string> = ko.observable();
    SummaryReportId: KnockoutObservable<string> = ko.observable();
    AreaId: KnockoutObservable<string> = ko.observable();
    AreaName: KnockoutObservable<string> = ko.observable();
    ShiftbookId: KnockoutObservable<string> = ko.observable();
    ShiftbookName: KnockoutObservable<string> = ko.observable();
    ShiftTypeName: KnockoutObservable<string> = ko.observable();
    ShiftTypeId: KnockoutObservable<string> = ko.observable();
    EquipmentId: KnockoutObservable<string> = ko.observable();
    EquipmentName: KnockoutObservable<string> = ko.observable();
    Device3Id: KnockoutObservable<string> = ko.observable();
    Device3Name: KnockoutObservable<string> = ko.observable();
    Device4Id: KnockoutObservable<string> = ko.observable();
    Device4Name: KnockoutObservable<string> = ko.observable();
    InfoStateId: KnockoutObservable<string> = ko.observable();
    InfoStateName: KnockoutObservable<string> = ko.observable();
    InfoLevelId: KnockoutObservable<string> = ko.observable();
    InfoLevelName: KnockoutObservable<string> = ko.observable();
    EnableSubcategory: KnockoutObservable<boolean> = ko.observable(false);
    ReportedToSappm: KnockoutObservable<boolean> = ko.observable(false);
    Monday: KnockoutObservable<boolean> = ko.observable(true);
    Tuesday: KnockoutObservable<boolean> = ko.observable(true);
    Wednesday: KnockoutObservable<boolean> = ko.observable(true);
    Thursday: KnockoutObservable<boolean> = ko.observable(true);
    Friday: KnockoutObservable<boolean> = ko.observable(true);
    Saturday: KnockoutObservable<boolean> = ko.observable(true);
    Sunday: KnockoutObservable<boolean> = ko.observable(true);
    UniversalFieldId: KnockoutObservable<string> = ko.observable();
    UniversalFieldName: KnockoutObservable<string> = ko.observable();
    UniversalFieldValue: KnockoutObservable<string> = ko.observable();
    Categories: KnockoutObservableArray<{
        CategoryFullName: string;
        CategoryStructureId: string;
    }> = ko.observableArray();
    CategoryStructureId: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel1: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel2: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel3: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel4: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel5: KnockoutObservable<string> = ko.observable();
    ShiftbookTypeId: KnockoutObservable<string> = ko.observable();
    SelectedCategoryStructure: KnockoutObservable<any> = ko.observable();
    CategoriesLoaded: KnockoutObservable<boolean> = ko.observable(false);
    ShiftbookSearcher: Bindings.baoSearcher;
    ShiftTypeSearcher: Bindings.baoSearcher;
    AreaSearcher: Bindings.baoSearcher;
    EquipmentSearcher: Bindings.baoSearcher;
    Device3Searcher: Bindings.baoSearcher;
    Device4Searcher: Bindings.baoSearcher;
    InfoStateSearcher: Bindings.baoSearcher;
    InfoLevelSearcher: Bindings.baoSearcher;
    UniversalfieldSearcher: Bindings.baoSearcher;
    UniversalFieldValueSearcher: Bindings.baoSearcher;
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        this.UniversalfieldSearcher = {
            SearchType: "Universalfield",
            ObjectId: this.UniversalFieldId,
            ObjectValue: "Description",
            AutoComplete: true,
            AutoSearch: true
        };
        this.ShiftbookSearcher = {
            SearchType: "Shiftbook",
            ObjectId: this.ShiftbookId,
            ObjectValue: "Name",
            AutoComplete: true,
            AutoSearch: true,
            CustomFilter: { ShiftbookTypeId: this.ShiftbookTypeId()}
        };
        this.ShiftTypeSearcher = {
            SearchType: "ShiftType",
            ObjectId: this.ShiftTypeId,
            ObjectValue: "Name",
            AutoComplete: true,
            AutoSearch: true
        };
        this.AreaSearcher = {
            SearchType: "Area",
            ObjectId: this.AreaId,
            ObjectValue: "ShortName",
            AutoComplete: true,
            AutoSearch: true
        };
        this.EquipmentSearcher = {
            SearchType: "Equipment",
            ObjectId: this.EquipmentId,
            ObjectValue: "EquipmentText",
            AutoComplete: true,
            AutoSearch: true
        };
        this.Device3Searcher = {
            SearchType: "Device3",
            ObjectId: this.Device3Id,
            ObjectValue: "Device3Name",
            AutoComplete: true,
            AutoSearch: true
        };
        this.Device4Searcher = {
            SearchType: "Device4",
            ObjectId: this.Device4Id,
            ObjectValue: "Device4Name",
            AutoComplete: true,
            AutoSearch: true
        };
        this.InfoStateSearcher = {
            SearchType: "State",
            ObjectId: this.InfoStateId,
            ObjectValue: "StateText",
            AutoComplete: true,
            AutoSearch: true
        };
        this.InfoLevelSearcher = {
            SearchType: "Priority",
            ObjectId: this.InfoLevelId,
            ObjectValue: "InfoLevelText",
            AutoComplete: true,
            AutoSearch: true
        };
        this.Categories.subscribe(() => {
            let selectedCategory = this.Categories().filter(c => c.CategoryStructureId === this.CategoryStructureId());
            if (selectedCategory.length > 0) {
                setTimeout(() => this.SelectedCategoryStructure(selectedCategory[0]), 0);
            }
        });
        this.SelectedCategoryStructure.subscribe((selectedCategory) => {
            if (selectedCategory && this.CategoriesLoaded()) {
                if (this.CategoryIdLevel1() !== selectedCategory.CategoryIdLevel1) {
                    this.CategoryIdLevel1(selectedCategory.CategoryIdLevel1);
                }
                if (this.CategoryIdLevel2() !== selectedCategory.CategoryIdLevel2) {
                    this.CategoryIdLevel2(selectedCategory.CategoryIdLevel2);
                }
                if (this.CategoryIdLevel3() !== selectedCategory.CategoryIdLevel3) {
                    this.CategoryIdLevel3(selectedCategory.CategoryIdLevel3);
                }
                if (this.CategoryIdLevel4() !== selectedCategory.CategoryIdLevel4) {
                    this.CategoryIdLevel4(selectedCategory.CategoryIdLevel4);
                }
                if (this.CategoryIdLevel5() !== selectedCategory.CategoryIdLevel5) {
                    this.CategoryIdLevel5(selectedCategory.CategoryIdLevel5);
                }
            }
            this.CategoriesLoaded(true);
        });
    }
    public init(): JQueryPromise<void> {
        return this.loadCategories();
    }
    private loadCategories = () => {
        this.Parent.TabPage.IsLoading(true);
        return Bao.post("SummaryReportFilterTab/GetCategories")
            .done(categories => {
                this.Categories(categories);
                this.Parent.TabPage.IsLoading(false);
            });
    };
}
export default SummaryReportFilterTabDialog;